const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the accept invite Directive which defines the sign in form behavior and markup
 * @argument {authorization} AuthorizationResource injected to access the authorization resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('accept', ['Users', 'Application', 'Authorization', 'Analyze', 'AuthorizationResource', 'i18n', '$translate', function(Users, Application, Authorization, Analyze, AuthorizationResource, i18n, $translate) {
    return {
      restrict: 'E',
      template: require('../../../templates/directives/preauth/accept.html'),
      controller: ['$scope', function($scope) {
        var self = this;
        var params = Application.navigation.getUrlParameters();
        self.passwordConfirm = '';
        self.loading = false;

        if (params.language) {
          i18n.language(params.language);
        }

        self.displaySuccess = false;
        var domain = Application.companyDomain;

        self.credentials = {
          first_name: params.fname,
          last_name: params.lname,
          key: params.key,
          email: params.email,
          domain: domain,
          password: ''
        };

        self.invalid = function() {
          if (!self.credentials.first_name || !self.credentials.last_name || !self.credentials.password) {
            return true;
          }
          if (self.credentials.password.length < 5 || self.credentials.password !== self.passwordConfirm) {
            return true;
          }
          return false;
        };

        self.accept = function() {
          if (!self.credentials.email || !self.credentials.first_name || !self.credentials.last_name || !self.credentials.password || !self.credentials.key) {
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidUrl'], duration: 10});
            return;
          }
          
          self.loading = true;
          Users.accept({}, self.credentials, function(data) {
            var login = {domain: Application.navigation.getHost(), email: self.credentials.email, password: self.credentials.password};
            AuthorizationResource.signin({}, login, async function(data) {
              if (Authorization.validateAndUseAuthToken(data)) {
                self.loading = false;
                Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
                Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
                Application.analyticsProvider.trackEvent('signin');

                var preRedirect = Application.storage.get('preRedirect');
                Application.storage.remove('preRedirect');
                Application.storage.remove('redirectParams');

                if (preRedirect) {
                  Application.navigation.goTo(preRedirect, {});
                  return;
                }

                Application.navigation.goToHome();
              }
            }, function(error) {
              self.loading = false;
              Authorization.clearAuthToken();
              console.log('Error', error);
              Application.messaging.addMessage({type: 'error', text: self.translations['preauth.invite.errorConfirmingInvitation'], duration: 10});
            });
          }, function(error) {
            self.loading = false;
            Authorization.clearAuthToken();
            console.log('Error', error);
            Application.messaging.addMessage({type: 'error', text: self.translations['preauth.invite.errorConfirmingInvitation'], duration: 10});
          });
        };

        setTimeout(function() {
          $translate([
            'modules.notifications.invalidCredentials',
            'modules.notifications.invalidCode',
            'preauth.invite.errorConfirmingInvitation'
          ]).then(function(data) {
            self.translations = data;
          });
        }, 1000);

      }],
      controllerAs: 'accept'
    };
  }]);
